import { Component, ChangeDetectionStrategy, inject, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ChangePassword } from './change-password/change-password';
import { TwoFactorSetup } from './twofa-setup/twofa-setup';
import { TwoFactor } from '../../../services/twofa';
import { TwoFactorStatus } from '../../../types/twofa';

@Component({
  selector: 'app-security',
  imports: [CommonModule, MatDialogModule],
  templateUrl: './security.html',
  styleUrl: './security.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Security implements OnInit {
  private dialog = inject(MatDialog);
  private twoFactor = inject(TwoFactor);

  twoFactorStatus = signal<TwoFactorStatus | null>(null);
  statusLoadFailed = signal(false);

  ngOnInit(): void {
    this.loadTwoFactorStatus();
  }

  private loadTwoFactorStatus(): void {
    this.twoFactor.getStatus().subscribe({
      next: (status) => {
        this.twoFactorStatus.set(status);
        this.statusLoadFailed.set(false);
      },
      error: () => {
        // Keep whatever we knew instead of falsely showing "disabled";
        // the template renders an "unknown" badge when nothing is loaded.
        this.statusLoadFailed.set(true);
      },
    });
  }

  openChangePasswordDialog(): void {
    this.dialog.open(ChangePassword, {
      width: '700px',
      minWidth: '700px',
      disableClose: false,
      panelClass: 'password-change-dialog'
    });
  }

  openTwoFactorDialog(): void {
    this.dialog
      .open(TwoFactorSetup, {
        width: '680px',
        minWidth: '680px',
        disableClose: false,
      })
      .afterClosed()
      .subscribe(() => this.loadTwoFactorStatus());
  }
}
